import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {CircularProgress} from '@mui/material';
import Box from '@mui/material/Box';

import Alert, {useAlert} from 'components/snacks/Alert';

import {axiosInstance} from 'api/Api';
import Sidebar from './Sidebar';

const Register = () => {
    // DATA
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState('');
    const [token, setToken] = useState('');
    const [name, setName] = useState('');
    const [family, setFamily] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userType, setUserType] = useState('1'); // 1 ==> real, 2 ==> legal
    const [nationalCode, setNationalCode] = useState('');
    const [company, setCompany] = useState('');
    const [nidNum, setNidNum] = useState('');
    const [economicalNumber, setEconomicalNumber] = useState('');
    const [registerNumber, setRegisterNumber] = useState('');

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    useEffect(() => {
        const phone = localStorage.getItem('login_phone_number');
        if (phone) {
            setPhoneNumber(phone);
        } else {
            history.push('/login');
        }
    }, []);

    const submitForm = (e) => {
        e.preventDefault();
        let error_message = '';
        if (token.length !== 5) {
            error_message = 'لطفا کد ۵ رقمی را درست وارد کنید.';
        } else if (name.length < 2) {
            error_message = 'نام باید حداقل ۲ کلمه باشد.';
        } else if (family.length < 2) {
            error_message = 'نام خاوادگی باید حداقل ۲ کلمه باشد.';
        } else if (
            !password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/i)
        ) {
            error_message =
                'کلمه عبور باید حداقل 8 کاراکتر بصورت ترکیبی از حروف و اعداد باشد.';
        } else if (!(userType === '1' || userType === '2')) {
            error_message = 'لطفا نوع حقیقی یا حقوقی بودن خود را مشخص کنید.';
        }
        // //////
        if (userType === '1') {  // real
            // if (nationalCode.length < 10) {
            //     error_message = "لطفا کد ملی را درست وارد کنید"
            // }
        } else { // legal
            if (company.length < 2) {
                error_message = "لطفا نام شرکت را کامل وارد کنید";
            } else if (nidNum.length < 2) {
                error_message = "لطفا شناسه ملی را کامل وارد کنید";
            } else if (economicalNumber.length < 2) {
                error_message = "لطفا شماره اقتصادی را کامل وارد کنید";
            } else if (registerNumber.length < 2) {
                error_message = "لطفا شماره ثبت را کامل وارد کنید";
            }
        }
        // //////
        if (error_message !== '') {
            alertStore.AddAlert({
                key: '422',
                message: error_message,
                severity: 'error',
                auto_hide: true
            });
        } else {
            setLoading(true);
            const formData = new FormData();
            formData.append('mobile', phoneNumber);
            formData.append('password', password);
            formData.append('verify_code', token);
            formData.append('first_name', name);
            formData.append('last_name', family);
            formData.append('email', email);
            formData.append('customer_type', userType);
            if (userType === '1'){
                formData.append('nid', nationalCode);
            } else {
                formData.append('company', company);
                formData.append('nid_num', nidNum);
                formData.append('economic_num', economicalNumber);
                formData.append('register_num', registerNumber);
            }
            axiosInstance()
                .post('/register', formData)
                .then((res) => {
                    if (res.data.status === 200) {
                        localStorage.setItem('token', res.data.token);
                        const urlParams = new URLSearchParams(window.location.search);
                        const product = urlParams.get('product');
                        const locale = urlParams.get('locale');
                        if (product) {
                            return history.push(`/services/server-iran/server-order?id=${product}`,  {
                                id: product
                            });
                        } else {
                            window.location.pathname = '/';
                        }
                    } else {
                        alertStore.AddAlert({
                            key: '400',
                            message: res.data.msg,
                            severity: 'error',
                            auto_hide: true
                        });
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    // JSX
    return (
        <div className={'row mx-0 px-0 '}>
            {/* **************** TITLE **************** */}
            <div className="col-12 col-md-6 px-0">
                <Sidebar/>
            </div>
            {/* **************** FORM **************** */}
            <div className="col-12 col-md-6 px-0">
                {loading ? (
                    <div className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0">
                        <Box sx={{display: 'flex', marginRight: '20px'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                ) : (
                    <form
                        method="post"
                        onSubmit={submitForm}
                        className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0"
                    >
                        <div style={{width: '65%'}}>
                            {/* **************** FORM TITLE **************** */}
                            <h3 className="text-dark mb-3 fs-3 text-center">
                                ایجاد حساب کاربری
                            </h3>
                            <div className="text-gray-400 fw-bold fs-4 text-center">
                                <span className="fs-7">آیا از قبل حساب کاربری دارید؟</span>
                                <a href="/login" className="link-primary fw-bolder ms-2 fs-7">
                                    اینجا کلیک کنید
                                </a>
                            </div>
                            {/* **************** FORM **************** */}
                            <div className="row mt-5">
                                {/* **************** FORM USER TYPE **************** */}
                                <div className="col-12">
                                    <div className="d-flex fv-row mb-4 fv-plugins-icon-container">
                                        <label className=" form-check-inline me-3" onClick={() => {
                                            setUserType('1');
                                        }}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="toc"
                                                value="1"
                                                onChange={() => {
                                                    setUserType('1');
                                                }}
                                                checked={userType === '1'}
                                                required
                                            />
                                            <span className="ms-2 cursor-pointer">حقیقی</span>
                                        </label>
                                        <label className=" form-check-inline me-3" onClick={() => {
                                            setUserType('2');
                                        }}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="toc"
                                                value="2"
                                                onChange={() => {
                                                    setUserType('2');
                                                }}
                                                checked={userType === '2'}
                                                required
                                            />
                                            <span className="ms-2 cursor-pointer">حقوقی</span>
                                        </label>
                                    </div>
                                </div>
                                {/* **************** FORM TOKEN **************** */}
                                <div className="col-12 mt-2">
                                    <label htmlFor="login_token" className="form-label">
                                        کد 5 رقمی خود را وارد نمایید:
                                    </label>
                                    <input
                                        type="tel"
                                        id="login_token"
                                        className="form-control login-input direction-ltr"
                                        placeholder="12345"
                                        max={5}
                                        onChange={(e) => {
                                            setToken(e.target.value);
                                        }}
                                        required
                                    />
                                </div>
                                {/* **************** FORM NAME **************** */}
                                <div className="col-12 col-lg-6 mt-5">
                                    <label htmlFor="login_name" className="form-label">
                                        {userType === '1' ? "نام :" : "نام مدیرعامل :"}
                                    </label>
                                    <input
                                        type="text"
                                        id="login_name"
                                        className="form-control login-input direction-ltr"
                                        placeholder=""
                                        onChange={(e) => {
                                            setName(e.target.value);
                                        }}
                                        required
                                    />
                                </div>
                                {/* **************** FORM FAMILY **************** */}
                                <div className="col-12 col-lg-6 mt-5">
                                    <label htmlFor="login_family" className="form-label">
                                    {userType === '1' ? "نام خانوادگی :" : "نام خانوادگی مدیرعامل :"}
                                    </label>
                                    <input
                                        type="text"
                                        id="login_family"
                                        className="form-control login-input direction-ltr"
                                        placeholder=""
                                        onChange={(e) => {
                                            setFamily(e.target.value);
                                        }}
                                        required
                                    />
                                </div>
                                {/* **************** NATIONAL CODE **************** */}
                                {/*{userType === '1' && <div className="col-12 mt-5">*/}
                                {/*    <label htmlFor="login_national_code" className="form-label">*/}
                                {/*        کد ملی:*/}
                                {/*    </label>*/}
                                {/*    <input*/}
                                {/*        type="text"*/}
                                {/*        id="login_national_code"*/}
                                {/*        className="form-control login-input direction-ltr"*/}
                                {/*        placeholder=""*/}
                                {/*        onChange={(e) => {*/}
                                {/*            setNationalCode(e.target.value);*/}
                                {/*        }}*/}
                                {/*        required*/}
                                {/*    />*/}
                                {/*</div>}*/}
                                {/* **************** LEGAL USER FIELDS **************** */}
                                {userType === '2' && <>
                                    {/* **************** COMPANY NAME **************** */}
                                    <div className="col-12 col-md-6 mt-5">
                                        <label htmlFor="login_company_name" className="form-label">
                                            نام شرکت:
                                        </label>
                                        <input
                                            type="text"
                                            id="login_company_name"
                                            className="form-control login-input direction-ltr"
                                            placeholder=""
                                            onChange={(e) => {
                                                setCompany(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    {/* **************** COMPANY NID NUMBER **************** */}
                                    <div className="col-12 col-md-6 mt-5">
                                        <label htmlFor="login_nid_number" className="form-label">
                                            شناسه ملی:
                                        </label>
                                        <input
                                            type="text"
                                            id="login_nid_number"
                                            className="form-control login-input direction-ltr"
                                            placeholder=""
                                            onChange={(e) => {
                                                setNidNum(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    {/* **************** COMPANY ECONOMICAL NUMBER **************** */}
                                    <div className="col-12 col-md-6 mt-5">
                                        <label htmlFor="login_economical_number" className="form-label">
                                            شماره اقتصادی:
                                        </label>
                                        <input
                                            type="text"
                                            id="login_economical_number"
                                            className="form-control login-input direction-ltr"
                                            placeholder=""
                                            onChange={(e) => {
                                                setEconomicalNumber(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    {/* **************** COMPANY REGISTER NUMBER **************** */}
                                    <div className="col-12 col-md-6 mt-5">
                                        <label htmlFor="login_register_number" className="form-label">
                                            شماره ثبت:
                                        </label>
                                        <input
                                            type="text"
                                            id="login_register_number"
                                            className="form-control login-input direction-ltr"
                                            placeholder=""
                                            onChange={(e) => {
                                                setRegisterNumber(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                </>}
                                {/* **************** FORM EMAIL **************** */}
                                <div className="col-12 col-md-6 mt-5">
                                    <label htmlFor="login_email" className="form-label">
                                        ایمیل :
                                    </label>
                                    <input
                                        type="email"
                                        id="login_email"
                                        className="form-control login-input direction-ltr"
                                        placeholder=""
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                        required
                                    />
                                </div>
                                {/* **************** FORM PASSWORD **************** */}
                                <div className="col-12 col-md-6 mt-5">
                                    <label htmlFor="login_password" className="form-label">
                                        کلمه عبور:
                                    </label>
                                    <input
                                        type="password"
                                        id="login_password"
                                        className="form-control login-input direction-ltr"
                                        placeholder=""
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                        }}
                                        required
                                    />
                                    <div className="text-muted mt-2">
                                        حداقل 8 کاراکتر بصورت ترکیبی از حروف و اعداد
                                    </div>
                                </div>
                            </div>
                            {/* **************** FORM SUBMIT **************** */}
                            <div className="text-center">
                                <button className="btn btn-primary mt-3">ثبت نام</button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </div>
    );
};

export default Register;
